import { Factory } from "@/data/dao/Factory";
import { PlanningDao } from "@/data/dao/service/PlanningDao";
import type { IPayApplication } from "@/data/model/PayApplication";
import { Format } from "@/data/util/Format";

import { translate } from "@/shared/localization/language";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { portalEvents } from "@/portal/events/portalEvents";

export class PayApplicationTableController {
    private $element: JQuery;
    private dao: PlanningDao;
    private dataTable: DataTable<IPayApplication>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<PlanningDao>(PlanningDao);

        const tableConfig: IDataTableConfig<IPayApplication> = {
            columnMapping: [
                {
                    name: i18n("general.fields.designation"),
                    property: "name",
                    formatter: (m) => Format.htmlEscape(translate(m.name)),
                },
                {
                    name: i18n("useCase.fields.tip"),
                    property: "useTip",
                    styles: { width: "8%" },
                    formatter: (m, p) => (p ? i18n("general.yes") : i18n("general.no")),
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
            defaultSortAsc: true,
            locationDependend: true,
            defaultSortProperty: "name",
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));
        this.dataTable = new DataTable<IPayApplication>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao.payUseCaseDataSource,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/pay-application/" + m.id;
            },
            (m) => {
                window.open("/pay-application/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
        portalEvents.OnLocationChanged.add(() => {
            this.dataTable.loadData(true);
        }, this);
    }
}
